import React from 'react';
import Spinner from '@cimpress/react-components/lib/shapes/Spinner';

var customLoadingOverlay = function customLoadingOverlay() {
  return React.createElement(Spinner, {
    className: "flex-center spinner-style"
  });
};

export default customLoadingOverlay;